import './jquery-global.js';
import '../scss/style.scss';
import './components.js';
import './home.js';
import 'jquery-match-height';

//smooth scroll
$(function () {
  var headerHeight = $('.header').outerHeight();
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      var target = $(urlHash);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }, 100);
  }
  $('a[href^="#"]').click(function (e) {
    var headerH = $('.js-header').outerHeight();
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'body' : href);
    if (!target.length) return;
    e.preventDefault();
    var position = target.offset().top - headerH;
    $('html, body').animate({ scrollTop: position }, 800, 'swing');
    // return false だと伝播が止まり、ナビの closeNav が走らないため preventDefault のみ
  });
});

// header fixed
$(window).on('load scroll', function () {
  $('.js-header').css('left', -$(window).scrollLeft());
});
// 固定ヘッダー分の body padding（リサイズでも追従）
function syncBodyHeaderPadding() {
  var $header = $('.js-header');
  if (!$header.length || $header.hasClass('lower_header')) {
    $('body').css('padding-top', '');
    return;
  }
  $('body').css('padding-top', $header.outerHeight() + 'px');
}
$(function () {
  syncBodyHeaderPadding();
});
$(window).on('load resize', syncBodyHeaderPadding);

// pagetop
$(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 600) {
      $('.js-pagetop').fadeIn();
    } else {
      $('.js-pagetop').fadeOut();
    }
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    var footerHeight = $('.js-footer').innerHeight();
    if (scrollHeight - scrollPosition <= footerHeight - 45) {
      $('.js-pagetop').addClass('is-stop');
    } else {
      $('.js-pagetop').removeClass('is-stop');
    }
  });
});

// tab
$(function () {
  $('.js-tab-btn__item').click(function () {
    var index = $(this).parent().children('.js-tab-btn__item').index(this);
    $(this).parent().children('.js-tab-btn__item').removeClass('is-active');
    $(this).addClass('is-active');
    $(this).parents('.js-tab-set').find('.js-tab-content').removeClass('is-show').eq(index).addClass('is-show');
  });
});

// text automatic omission
jQuery(function ($) {
  $('.js-text-overflow').each(function () {
    var $target = $(this);
    var html = $target.html();
    var $clone = $target.clone();
    $clone
      .css({
        display: 'none',
        position: 'absolute',
        overflow: 'visible'
      })
      .width($target.width())
      .height('auto');
    $target.after($clone);
    while (html.length > 0 && $clone.height() > $target.height()) {
      html = html.substr(0, html.length - 1);
      $clone.html(html + '...');
    }
    $target.html($clone.html());
    $clone.remove();
  });
});

// search window
$(function () {
  $('.js-header-top-search-open').click(function () {
    $(this).addClass('is-hide');
    $('.js-header-top-search-txt').addClass('is-open');
    $('.js-header-top-search-overlay').fadeIn();
  });
  $('.js-header-top-search-overlay').click(function () {
    $(this).fadeOut();
    $('.js-header-top-search-txt').removeClass('is-open');
    $('.js-header-top-search-open').removeClass('is-hide');
  });
});

$(function () {
  $('.recipe2020-sec__midList__txtBox').matchHeight();
  $('.recipe2020-sec__midList__txt').matchHeight();
  $('.recipe2020-sec__midList__list').matchHeight();
  $('.recipe2020-sec__midList__ttl .title').matchHeight();

  $('.recipe2021-sec__midList__txtBox').matchHeight();
  $('.recipe2021-sec__midList__txt').matchHeight();
  $('.recipe2021-sec__midList__list').matchHeight();
  $('.recipe2021-sec__midList__ttl .title').matchHeight();

  $('.recipe2022-sec__midList__ttl .title, .recipe2023-sec__midList__ttl').matchHeight();

  $('.js-matchheight').matchHeight();
});

// プルダウン
$('.js-pullDown-bt01').on('click', function (event) {
  event.preventDefault();
  $('.js-pullDown01').slideToggle();
});
$('.js-pullDown-bt02').on('click', function (event) {
  event.preventDefault();
  $('.js-pullDown02').slideToggle();
});
$('.js-pullDown-bt03').on('click', function (event) {
  event.preventDefault();
  $('.js-pullDown03').slideToggle();
});

// プルダウン
$('.js-pullDown-bt').on('click', function (event) {
  event.preventDefault();
  $(this).toggleClass('is_open');
  const isOpen = $(this).hasClass('is_open');
  $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
  $(this).next().slideToggle();
});
